export const channelOptsEverything = {
  watch: true, // send channel updates and messages
  state: true, // include messages & data
  presence: true, // follow user online changes
  limit: 30,
};

export const channelOptsNothing = {
  watch: false, // send channel updates and messages
  state: false, // include messages & data
  presence: false, // follow user online changes
};

export const ROOM_TYPE = "team";

export const DM_TYPE = "messaging";

// 25 messages are attached to our raw channel on initialization inside loadInitialState
// we don't have control over that initial size so we matched up our page size with that initial page size
export const MESSAGE_PAGE_SIZE = 25;

export const TEMPORARY_MESSAGE_PREFIX = "00000000-0000-0000-0000-";
